export const connectorsSchema = {
    type: 'object',
    properties: {
        connectors: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    name: { type: 'string' },
                    bciti_certified: { type: 'boolean' },
                    description: { type: 'string' },
                    endpoints: {
                        type: 'array',
                        items: {
                            type: 'object',
                            properties: {
                                url: { type: 'string' },
                                action: { type: 'string' },
                            },
                        },
                    },
                    type: { type: 'string' },
                    version: { type: 'string' },
                    configurations: {
                        type: 'array',
                        items: {
                            type: 'object',
                            properties: {
                                description: { type: 'string' },
                                required: { type: 'boolean' },
                                key: { type: 'string' },
                            },
                        },
                    },
                    technical_contact: { type: 'string' },
                    tag: { type: 'string' },
                    lookup: { type: 'boolean' },
                },
            },
        },
    },
};
